"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQRLogin = void 0;
const react_1 = require("react");
/**
 * Shared hook for QR code login flow.
 * Requests QR from API, generates data URL, polls for approval.
 */
function useQRLogin(options) {
    const { apiBaseUrl, loginContext, tokenStorageKey, enabled, onError, } = options;
    const [qrDataUrl, setQrDataUrl] = (0, react_1.useState)('');
    const [qrToken, setQrToken] = (0, react_1.useState)('');
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const base = apiBaseUrl.replace(/\/api\/v1\/?$/, '');
    (0, react_1.useEffect)(() => {
        if (!enabled)
            return;
        setIsLoading(true);
        fetch(`${base}/api/v1/auth/qr/request`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                origin: typeof window !== 'undefined' ? window.location.origin : '',
                loginContext,
            }),
        })
            .then((r) => r.json())
            .then(async (data) => {
            if (data.qrToken && data.qrData) {
                setQrToken(data.qrToken);
                try {
                    const { default: QRCode } = await Promise.resolve().then(() => __importStar(require('qrcode')));
                    const url = await QRCode.toDataURL(data.qrData, { width: 200 });
                    setQrDataUrl(url);
                }
                catch {
                    onError?.('Could not generate QR code');
                }
            }
            else {
                onError?.('Could not load QR code');
            }
        })
            .catch(() => onError?.('Could not load QR code'))
            .finally(() => setIsLoading(false));
    }, [enabled, loginContext, base, onError]);
    (0, react_1.useEffect)(() => {
        if (!qrToken)
            return;
        const interval = setInterval(async () => {
            try {
                const res = await fetch(`${base}/api/v1/auth/qr/status/${qrToken}`);
                const data = await res.json();
                if (data.status === 'approved' && data.token && typeof window !== 'undefined') {
                    localStorage.setItem(tokenStorageKey, data.token);
                    window.location.href = '/';
                }
            }
            catch {
                // ignore
            }
        }, 1500);
        return () => clearInterval(interval);
    }, [qrToken, base, tokenStorageKey]);
    return { qrDataUrl, qrToken, isLoading };
}
exports.useQRLogin = useQRLogin;
